import React from "react"
import { Container, Row, Col, Form, Input, FormGroup } from "reactstrap"
import stellarProcessing from "../../view/assets/stellar-animation.gif"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import { WarningMessage } from "../../view/shared/notifications/Notifications"
import { connect } from "react-redux"
import LastWriteOff from "../reverseTransactions/LastWriteOff"
import { currentTransactionContext } from "../../store/actions/transactionContext"
import { selectMemberTrasactions } from "../../store/reducers/getTransactions"
import { getCurrency } from "../../view/shared/utilities/currency"
import { initiateTransaction } from "../../store/reducers/transactions/actions"
import { selectCreatedVslaInfo } from "../../store/reducers/getVslas"
import { setCurrentPage } from "../../store/reducers/navigation"

const notify = (msg) => toast(msg)

const WriteOffLoan = (props) => {
  const { i18n } = useLingui()
  React.useEffect(() => {
    props.pushTransactionContext("Loan write-off")
  }, [])

  const [state, setState] = React.useState({
    amount: "",
    asset: "SC",
    source: "fund",
    dest: "member",
    loading: false,
    errors: {},
    lang: i18n.locale,
  })

  const redirectBack = () => {
    props.setPage("group-memberActions")
  }

  const onSubmit = (e) => {
    e.preventDefault()
    processTransaction(isPayable(), state.asset, state.source, state.dest)
  }

  const isPayable = () => {
    let outstandingLoan = 0

    if (props.memberDebt(props.currentMember?.pubkey).balance > 0) {
      outstandingLoan = props.memberDebt(props.currentMember?.pubkey).balance
      return outstandingLoan
    }
    return outstandingLoan
  }

  const processTransaction = (amount) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmez la suppression du prêt de ${parseFloat(
          amount,
        )} pour le membre`,
      },
      en: {
        message: `Confirm loan write-off of ${parseFloat(amount)} for member`,
      },
      sw: {
        message: `Thibitisha kufuta mkopo wa shilingi ${parseFloat(
          amount,
        )} kwa mwanachama`,
      },
      ZARMA: {
        message: `Zarma for Confirm loan write-off of ${parseFloat(
          amount,
        )} for member`,
      },
      HAOUSSA: {
        message: `Haoussa for r Confirm loan write-off of ${parseFloat(
          amount,
        )} for member`,
      },
      es: {
        message: `Confirmar la cancelación del préstamo de ${parseFloat(
          amount,
        )} lempiras para el miembro`,
      },
      lb: {
        message: `Confirm loan write-off of ${parseFloat(amount)} for household`,
      },
      pt: {
        message: `Confirme a eliminação do empréstimo de ${parseFloat(
          amount,
        )} para o membro`,
      },
      ar: {
        message: ` (${parseFloat(amount)}) أكد شطب القرض `,
      },
    }

    const meetingId = props.ongoingMeeting?.id
      ? props.ongoingMeeting?.id
      : props.ongoingMeeting?.cacheId

    if (window.confirm(lang[lang_code].message) && isPayable()) {
      setState({ ...state, loading: true })
      const uuid = props.currentMember?.pubkey

      props.commitTransaction({
        uid: uuid,
        type: "WRITE_OFF_LOAN",
        amount: parseFloat(amount),
        ...(props.currentMember?.id
          ? {
            member_id: props.currentMember?.id,
          }
          : {
            memberCacheId:
              props.currentMember?.cacheId || props.currentMember?.pubkey,
          }),
      })
      notify(<WarningMessage msg={"Processing Transaction"} />)
      props.setPage("group-memberList")
    } else {
      notify(<WarningMessage />)
    }
  }

  if (!state.loading) {
    return (
      <Container>
        <div>
          <h4
            style={{
              color: "#E36F1E",
              fontFamily: "quicksand",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {props.currentMember?.full_name}
          </h4>
        </div>
        <div style={{ padding: ".5rem", textAlign: "center" }}>
          <h4
            style={{
              color: "#E36F1E",
              fontFamily: "quicksand",
              fontWeight: "bold",
            }}
          >
            <Trans id="loan.write.off">Loan Write-Off</Trans>
          </h4>
        </div>
        <p>This action will remove the loan records for member:</p>
        <p
          style={{
            fontFamily: "Fira Sans",
            fontSize: "16px",
            color: "#696969",
          }}
        >
          <Trans id="outstanding.loan">Outstanding Loan</Trans>{" "}
          {parseFloat(isPayable()).toFixed(2)}{" "}
          {getCurrency(props.group?.country).symbol}
        </p>

        <p
          style={{
            fontFamily: "Fira Sans",
            fontSize: "16px",
            color: "#696969",
          }}
        >
          <Trans id="outstanding.loan.interest">Outstanding Loan Interest</Trans>{" "}
          {parseFloat(
            props.loanInterest(props.currentMember?.pubkey).balance,
          ).toFixed(2)}{" "}
          {getCurrency(props.group?.country).symbol}
        </p>

        <Row>
          <br />
          <Col>
            <Form onSubmit={onSubmit}>
              <Container>
                <FormGroup>
                  <Input
                    disabled={!isPayable()}
                    type="submit"
                    value={i18n._("Loan Write-Off")}
                    name="submit"
                    className="btn btn-primary"
                  />
                </FormGroup>
              </Container>
            </Form>
          </Col>
        </Row>
        {props.isConnected && (
          <LastWriteOff
            offlineMeeting={props.offlineMeeting}
            redirectBack={() => {
              redirectBack()
            }}
            reversal_details={{
              reversalTransactionType: "Write-off reversed",
            }}
            transactions={props.transactions}
          />
        )}
      </Container>
    )
  }

  return (
    <div>
      <center>
        <img
          src={stellarProcessing}
          style={{ height: "90%", width: "90%" }}
          alt="Stellar"
        />
      </center>
    </div>
  )
}

WriteOffLoan.propTypes = {
  vsla: PropTypes.object,
  pushTransactionContext: PropTypes.func,
  setPage: PropTypes.func,
  memberDebt: PropTypes.func,
  currentMember: PropTypes.object,
  commitTransaction: PropTypes.func,
  ongoingMeeting: PropTypes.object,
  group: PropTypes.object,
  loanInterest: PropTypes.func,
  isConnected: PropTypes.bool,
  offlineMeeting: PropTypes.object,
  transactions: PropTypes.array,
}

const mapStateToProps = (state) => {
  const { account, accountV2, loadedMember } = state

  const createMemberBalanceSelector = (accountType) => (pubkey) => {
    if (!pubkey) return { balance: 0 } // Return a default object if no pubkey

    // Priority 1: Check offline state using pubkey
    if (accountV2.offline?.members[pubkey]) {
      return accountV2.offline.members[pubkey][accountType]
    }

    if (account.members[pubkey]) {
      return account.members[pubkey][accountType]
    }

    return { balance: 0 } // Return a default object if not found
  }
  const selectMemberReversableTransactions = (type) => {
    const memberPubkey = loadedMember?.pubkey
    if (!memberPubkey) {
      return []
    }
    else if (!accountV2.online?.transactions) {
      return []
    }
    return accountV2.online?.transactions?.[memberPubkey]?.filter(tx => tx.type === type) || []
  }
  return {
    isConnected: state.isConnected,
    user: state.user,
    ongoingMeeting: state.meeting?.ongoing,
    memberDebt: createMemberBalanceSelector("loan"),
    loanInterest: createMemberBalanceSelector("loan_interest"),
    currentMember: state.loadedMember,
    transactions: selectMemberReversableTransactions('WRITE_OFF_LOAN'),
    group: state.group,
    vslaSummary: selectCreatedVslaInfo(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    commitTransaction: (data) => dispatch(initiateTransaction(data)),
    pushTransactionContext: (type) => dispatch(currentTransactionContext(type)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WriteOffLoan)
